import { graphql } from '@/generated/gql'

export const GET_MINUTES_REQUESTS = graphql(`
    query moms ($first: Int, $after:String, $order: [MOMSortInput!], $where: MOMFilterInput, $textFilterInput: TextFilterInput) {
        moms(first: $first, after: $after, order:$order, where: $where, textFilterInput: $textFilterInput) {
            pageInfo {
                hasNextPage
                endCursor
            }
            totalCount
            nodes {
                __typename
                id
                status
                name
                dueDate
                createdAtUtc
                meetingId
                permissions
                message
                type
                size
                version
                documentLink
                previewDocumentLink
                approvers {
                    response
                    approvedAt
                    user {
                        id
                        fullName
                        firstName
                        lastName
                        displayName
                        email
                        imageUrl
                        role
                        meetplaceId
                        isConfirmedEmail
                        jobTitle
                        userStatus
                    }
                }
                meeting {
                    id
                    title
                    meetingStartDateUtc
                    meetingEndDateUtc
                }
            }
        }
    }
`)

export const GET_MINUTES_REQUEST = graphql(`query Mom($momId: ReadMOMInput!) {
  mom(input: $momId) {
    id
    name
    approvers {
      userId
      response
      approvedAt
      user {
        id
        firstName
        lastName
        email
        imageUrl
        role
      }
    }
    requireSignature
    type
    size
    version
    permissions
    message
    createdAtUtc
    dueDate
    meetingId
    documentLink
    previewDocumentLink
    status
    requester {
      userId
    }
    attachments {
      id
      title
      attachmentPath
      meetingId
    }
    meeting {
      id
      title
      permissions
      myMeetingRole
      meetplaceId
      creator {
        userId
      }
      linkedGroups {
        id
        title
      }
      attendees{
        user {
          id
          displayName
          firstName
          lastName
          email
          imageUrl
          role
          meetplaceId
        }    
      }
    }
    tags {
      nodes {
        tagId
        tagName   
      }
      totalCount
    }
    reactions {
      reactionSymbol
    }
    comments {
      totalCount
    }
    linkedDecisions {
      id
      title
      meetingId
      owners {
        userId
        email
        user {
          id
          fullName
          firstName
          lastName
          email
          imageUrl
          role
          jobTitle
        }
      }
    }
    linkedPolls {
      id
      question
      meetingId
    }
    linkedAttachments {
      id
      title
      meetingId
    }
    linkedMOMs {
      id
      type
      name
      meetingId
    }
    linkedNotes {
      body
      id
      meetingId
    }
    linkedAgendaItems {
      id
      name
      duration
      meetingId
      isCompleted
      speakers{
        user {
          id
          fullName
          firstName
          lastName
          email
          imageUrl
          role
          jobTitle
        }
      }
    }
    linkedActions {
      id
      parentAction {
        id
      }
      title
      dueDate
      meetingId
      completeStatus {
        isCompleted
      }
      assignees {
        assigneeRole
        userId
        email
        meetplaceId
        user {
          id
          firstName
          lastName
          email
          imageUrl
          role
        }
      }
      delegatees {
        assigneeRole
        userId
        email
        meetplaceId
        user {
          id
          firstName
          lastName
          email
          imageUrl
          role
        }
      }
    }
  }
}`)

export const UNLINK_MOM =
    graphql(`mutation unLinkMOMFrom($input: RemoveLinkInput!){
  unLinkMOMFrom(input: $input){
    mom {
      id
      linkedDecisions {
        id
        title
        meetingId
        owners {
          userId
          email
          user {
            id
            firstName
            lastName
            email
            imageUrl
            role
          }
        }
      }
      linkedPolls {
        id
        question
        meetingId
      }
      linkedAttachments {
        id
        title
        meetingId
      }
      linkedMOMs {
        id
        type
        name
        meetingId
      }
      linkedNotes {
        body
        id
        meetingId
      }
      linkedAgendaItems {
        id
        name
        duration
        meetingId
        isCompleted
        speakers{
          user {
            id
            firstName
            lastName
            email
            imageUrl
            role
          }
        }
      }
      linkedActions {
        id
        parentAction {
          id
        }
        title
        dueDate
        meetingId
        completeStatus {
          isCompleted
        }
        assignees {
          assigneeRole
          userId
          email
          meetplaceId
          user {
            id
            firstName
            lastName
            email
            imageUrl
            role
          }
        }
        delegatees {
          assigneeRole
          userId
          email
          meetplaceId
          user {
            id
            firstName
            lastName
            email
            imageUrl
            role
          }
        }
      }
    }
  }
}`)

export const LINK_MOM = graphql(`mutation LinkMOMTo($input: AddLinkInput!){
  linkMOMTo(input: $input){
    mom {
      id
      linkedDecisions {
        id
        title
        meetingId
        owners {
          userId
          email
          user {
            id
            firstName
            lastName
            email
            imageUrl
            role
          }
        }
      }
      linkedPolls {
        id
        question
        meetingId
      }
      linkedAttachments {
        id
        title
        meetingId
      }
      linkedMOMs {
        id
        type
        name
        meetingId
      }
      linkedNotes {
        body
        id
        meetingId
      }
      linkedAgendaItems {
        id
        name
        duration
        meetingId
        isCompleted
        speakers{
          user {
            id
            firstName
            lastName
            email
            imageUrl
            role
          }
        }
      }
      linkedActions {
        id
        parentAction {
          id
        }
        title
        dueDate
        meetingId
        completeStatus {
          isCompleted
        }
        assignees {
          assigneeRole
          userId
          email
          meetplaceId
          user {
            id
            firstName
            lastName
            email
            imageUrl
            role
          }
        }
        delegatees {
          assigneeRole
          userId
          email
          meetplaceId
          user {
            id
            firstName
            lastName
            email
            imageUrl
            role
          }
        }
      }
    }
  }
}`)
